import { render, staticRenderFns } from "./inverterFailure.vue?vue&type=template&id=324e1556&scoped=true"
import script from "./inverterFailure.vue?vue&type=script&lang=js"
export * from "./inverterFailure.vue?vue&type=script&lang=js"
import style0 from "./inverterFailure.vue?vue&type=style&index=0&id=324e1556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e1556",
  null
  
)

export default component.exports